import axios from '@/request';
import qs from 'qs';

export default {
  async logincaptcha(params: any) {
    return axios.get('cap/digitC', { params });
  },
  async getUser(params: any) {
    return axios.get('admin/info', { params });
  },
  async saveInfo(params: any) {
    return axios.post('admin/saveinfo', qs.stringify(params));
  },
  async changePwd(params: any) {
    return axios.post('admin/update_password', qs.stringify(params));
  },
  async logout(params: any) {
    return axios.get('admin/logout', { params });
  },
  async login(params: any) {
    return axios.post('admin/login', qs.stringify(params));
  },
  async refreshToken(params: any) {
    return axios.get('admin/refresh-token', { params });
  },
  async getcaptcha(params: any) {
    return axios.post('user/getcaptcha', qs.stringify(params));
  },
  async resetpwd(params: any) {
    return axios.post('user/resetpwd', qs.stringify(params));
  },
  async sug(params: any) {
    return axios.get('user/sug', { params });
  },
  async perms(params: any) {
    return axios.get('admin/perms', { params });
  },
  async menus(params: any) {
    return axios.get('admin/menus', { params });
  },
  async balance(params: any) {
    return axios.get('user/balance', { params });
  },
  async withdraw(params: any) {
    return axios.post('user/withdraw', qs.stringify(params));
  },
};
